import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsYogaNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6 35.513a4.5 4.5 0 001.91.427 5.22 5.22 0 002.15-.49L46 25.508V22.9l-18-9-14.18 6.186-4.15-2.016a5 5 0 00-3.27-.6 5.85 5.85 0 00-4.88 6 4.81 4.81 0 002.469 4.014l-.006.012 16.614 8.024.003-.007zm.545-1.95a3.41 3.41 0 01-1.725-2.923 4.386 4.386 0 010-.47l4.77 2.4.47-.27a4.15 4.15 0 002.05-4.72 3.74 3.74 0 00-2.2-2.33l-.024-.01.013-.025-8.29-3.981L28 16.1l16.13 8.13-20.31 9.45a2.83 2.83 0 01-2.41 0l-.25-.14-.015.023zM17.43 30.63c.003.41.052.816.146 1.21L5.01 25.771l.01-.02a2.85 2.85 0 01-1.53-2.43 3.79 3.79 0 013.18-3.87 2.91 2.91 0 011.672.184L20.37 25.45a5.257 5.257 0 00-2.94 4.509v.67zm4.93-3.72a3.05 3.05 0 011.271.107h.002c.08.025.159.052.237.083a1.68 1.68 0 011 1.07 2 2 0 01-.73 2.08l-4-2a3.27 3.27 0 012.22-1.34z"
        fill=""
      />
    </svg>
  )
);
SvgSportsYogaNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsYogaNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsYogaNormalLarge;
